import { render } from "./ItemDeVariavel.vue?vue&type=template&id=0303a198&ts=true"
import script from "./ItemDeVariavel.vue?vue&type=script&lang=ts"
export * from "./ItemDeVariavel.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__